<template>
  <div
    v-if="alertIsVisible"
    class="
      mt-6
      px-5
      py-4
      sm:mx-6
      lg:mx-8
      flex
      items-center
      font-normal
      text-sm text-gray-900
      rounded-lg
      shadow-md
      bg-vice-rose-400
      dark:bg-gray-800
      dark:text-red-400
      dark:border-red-800
    "
    role="alert"
  >
    <CrossedCircleBlack class="flex-shrink-0 w-6 h-6 mr-4" />
    <span class="sr-only">Info</span>
    <div class="ms-3">
      <span class="font-semibold text-black">Set up two-factor authentication:</span>
      Add a phone number or use an authenticator app to
      <jet-nav-link
        :href="getLinkToProfilepage()"
        class="underline hover:no-underline profile-link font-medium"
      >
        enhance your account security.
      </jet-nav-link>
    </div>
    <button
      type="button"
      class="ms-auto -mx-1.5 -my-1.5 inline-flex items-center justify-center h-6 w-6 ml-auto"
      aria-label="Close"
      @click="closeAlert()"
    >
      <span class="sr-only">Close</span>
      <CrossedBlackIcon />
    </button>
  </div>
</template>
<script>
// All component logic in ProfileAlertMixin.vue!!!
import ProfileAlertMixin from '@/Mixins/ProfileAlertMixin.vue';
import { ALERTS_SEEN_COOKIES_NAMES } from '@/Utils/vice-constants';
import CrossedBlackIcon from '@/Components/Icons/CrossedBlackIcon.vue';
import CrossedCircleBlack from '@/Components/Icons/CrossedCircleBlack.vue';

export default {
  name: 'TwoFactorAuthAlert',
  components: { CrossedBlackIcon, CrossedCircleBlack },
  mixins: [ProfileAlertMixin],
  data() {
    return {
      profileSectionName: 'two_factor_confirmed',
      alertSeenCookieName: ALERTS_SEEN_COOKIES_NAMES.TWO_FACTOR_AUTH_ALERT_SEEN,
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    '$page.props.user.two_factor_confirmed': function (newValue) {
      this.alertIsVisible = newValue !== 1;
    },
  },
};
</script>

<style scoped>
.profile-link {
  color: inherit;
  padding: 0;
}

.profile-link:hover {
  background: none;
}
</style>
